import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
export default class EditCustomPageModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "contentText", void 0);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "textareaElement", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    let initialContent = '';
    if (this.attrs.customPage) {
      initialContent = this.attrs.customPage.content() || '';
    } else {
      var _app$forum;
      const template = ((_app$forum = app.forum) == null ? void 0 : _app$forum.attribute('huseyinfiliz-custom-profile-page.default_template')) || '';
      initialContent = template;
    }
    this.contentText = Stream(initialContent);
  }
  className() {
    return 'EditCustomPageModal Modal--large';
  }
  title() {
    return app.translator.trans('huseyinfiliz-custom-profile-page.forum.edit_modal.title');
  }
  content() {
    var _app$forum2;
    const format = ((_app$forum2 = app.forum) == null ? void 0 : _app$forum2.attribute('huseyinfiliz-custom-profile-page.content_format')) || 'markdown';
    const isMarkdown = format === 'markdown';
    return m('.Modal-body', [m('.Form', [this.renderFormatInfo(format), isMarkdown && this.renderMarkdownToolbar(), m('.Form-group', [this.renderTextarea()]), m('.Form-group.EditCustomPageModal-actions', [Button.component({
      type: 'submit',
      className: 'Button Button--primary',
      loading: this.loading,
      disabled: this.loading
    }, app.translator.trans('huseyinfiliz-custom-profile-page.forum.edit_modal.submit_button')), ' ', Button.component({
      className: 'Button',
      disabled: this.loading,
      onclick: () => this.hide()
    }, app.translator.trans('huseyinfiliz-custom-profile-page.forum.profile_tab.cancel_button'))])])]);
  }
  renderFormatInfo(format) {
    let icon = '';
    let text = '';
    if (format === 'markdown') {
      icon = 'fab fa-markdown';
      text = app.translator.trans('huseyinfiliz-custom-profile-page.forum.edit_modal.markdown_help');
    } else if (format === 'html') {
      var _app$forum3;
      const allowedTags = ((_app$forum3 = app.forum) == null ? void 0 : _app$forum3.attribute('huseyinfiliz-custom-profile-page.allowed_html_tags')) || '';
      icon = 'fab fa-html5';
      text = app.translator.trans('huseyinfiliz-custom-profile-page.forum.edit_modal.html_help', {
        tags: allowedTags
      });
    } else {
      icon = 'fas fa-align-left';
      text = app.translator.trans('huseyinfiliz-custom-profile-page.forum.edit_modal.text_help');
    }
    return m('.Alert.EditCustomPageModal-formatInfo', [m('i.icon', {
      className: icon
    }), m('span', text)]);
  }
  renderMarkdownToolbar() {
    return m('.MarkdownToolbar.ButtonGroup', [this.toolbarButton('Heading', 'fas fa-heading', '\n## ', ''), this.toolbarButton('Bold', 'fas fa-bold', '**', '**'), this.toolbarButton('Italic', 'fas fa-italic', '*', '*'), this.toolbarButton('Strikethrough', 'fas fa-strikethrough', '~~', '~~'), this.toolbarButton('Quote', 'fas fa-quote-left', '\n> ', ''), this.toolbarButton('Spoiler', 'fas fa-eye-slash', '>!', '!<'), this.toolbarButton('Code', 'fas fa-code', '`', '`'), this.toolbarButton('Link', 'fas fa-link', '[', '](url)'), this.toolbarButton('Image', 'fas fa-image', '![', '](image-url)'), this.toolbarButton('Bulleted List', 'fas fa-list-ul', '\n- ', ''), this.toolbarButton('Numbered List', 'fas fa-list-ol', '\n1. ', ''), this.toolbarButton('Mention', 'fas fa-at', '@', '')]);
  }
  toolbarButton(name, icon, before, after) {
    return m('button.Button.Button--icon.Button--link', {
      type: 'button',
      title: name,
      onclick: e => {
        e.preventDefault();
        this.insertMarkdown(before, after);
      }
    }, m('i', {
      className: icon
    }));
  }
  insertMarkdown(before, after) {
    if (!this.textareaElement) return;
    const textarea = this.textareaElement;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = this.contentText();
    const selectedText = text.substring(start, end);
    const newText = text.substring(0, start) + before + selectedText + after + text.substring(end);
    this.contentText(newText);
    setTimeout(() => {
      const newCursorPos = start + before.length + selectedText.length;
      textarea.focus();
      textarea.setSelectionRange(newCursorPos, newCursorPos);
      m.redraw();
    }, 0);
  }
  renderTextarea() {
    return m('textarea.FormControl', {
      rows: 20,
      value: this.contentText(),
      oninput: e => {
        this.contentText(e.target.value);
      },
      oncreate: vnode => {
        this.textareaElement = vnode.dom;
      },
      placeholder: app.translator.trans('huseyinfiliz-custom-profile-page.forum.edit_modal.content_placeholder'),
      disabled: this.loading
    });
  }
  onsubmit(e) {
    if (e) e.preventDefault();
    if (this.loading) return;
    this.loading = true;
    const userId = this.attrs.user.id();
    const data = {
      type: 'custom-profile-pages',
      attributes: {
        content: this.contentText()
      }
    };
    const method = this.attrs.customPage ? 'PATCH' : 'POST';
    const url = "".concat(app.forum.attribute('apiUrl'), "/users/").concat(userId, "/custom-page");
    app.request({
      method,
      url,
      body: {
        data
      }
    }).then(response => {
      this.loading = false;
      if (response.data) {
        const page = app.store.pushPayload(response);
        if (this.attrs.onSave) {
          this.attrs.onSave(page);
        }
      }
      this.hide();
      m.redraw();
    }).catch(() => {
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('huseyinfiliz-custom-profile-page.forum.edit_modal.error'));
      m.redraw();
    });
  }
}
flarum.reg.add('huseyinfiliz-custom-profile-page', 'forum/components/EditCustomPageModal', EditCustomPageModal);